import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import AdvisorStudentsStudentProfileTab from "../../Container/Advisor_Students/StudentTabs/AdvisorStudentsStudentProfileTab";
import PersonService from "../../../Services/Person.service";
import TabsLayout from "../../Layout/TabsLayout";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import PersonTypeContextProvider from "../../Hooks/usePersonType";
const DuplicateProfileView = ({ affiliationId, fullName, }) => {
    const [personState, loadPerson] = useService(PersonService.getPersonWithAlertRecipients);
    React.useEffect(() => {
        loadPerson(affiliationId);
    }, [loadPerson, affiliationId]);
    const tabs = [
        {
            tab: "Profile",
            content: (_jsx(ServiceResult, { state: personState, children: (data) => (_jsx(PersonTypeContextProvider, { internalName: "student", children: _jsx(AdvisorStudentsStudentProfileTab, { student: data, 
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        setStudent: () => { }, onCase: true, duplicationView: true }) })) })),
            id: "Profile",
        },
    ];
    return (_jsxs("div", { className: "border border-primary rounded p-3", style: { width: "50%" }, children: [_jsx("h5", { className: "text-primary", children: fullName }), _jsx(TabsLayout, { tabs: tabs, tabStyle: "underline", children: ({ content, tabsInternal }) => (_jsxs("div", { children: [tabsInternal, _jsx("div", { className: "mt-3", children: content })] })) })] }));
};
export default DuplicateProfileView;
